/* Robot kiwi variant — square body, antenna, screen eye. */

import type { KiwiPalette } from "../kiwiPalettes";

export function renderRobot(p: KiwiPalette) {
  return (
    <>
      {/* Antenna */}
      <rect x="15" y="0" width="2" height="4" fill={p.accent} opacity={0.5} />
      <rect x="14" y="0" width="4" height="2" fill={p.accent} opacity={0.4} />
      {/* Body — more rectangular/robotic */}
      <path d="M8 4H24V6H26V22H24V26H8V22H6V6H8V4Z" fill={p.body} />
      {/* Panel lines */}
      <rect x="8" y="16" width="18" height="2" fill={p.highlight} opacity={0.2} />
      {/* Beak — metallic */}
      <path d="M4 10H6V12H4V10ZM2 12H4V14H2V12ZM2 14H4V16H2V14ZM4 16H6V18H4V16Z" fill={p.beak} />
      {/* Screen eye */}
      <rect x="10" y="8" width="8" height="6" fill={p.eyeBg} />
      <rect x="12" y="10" width="2" height="2" fill={p.pupil} />
      <rect x="15" y="10" width="1" height="2" fill={p.pupil} opacity={0.5} />
      {/* Bolts on body */}
      <rect x="22" y="8" width="2" height="2" fill={p.accent} opacity={0.4} />
      <rect x="22" y="20" width="2" height="2" fill={p.accent} opacity={0.4} />
      {/* Feet — blocky */}
      <path d="M10 26H14V30H10V26Z" fill={p.body} />
      <path d="M18 26H22V30H18V26Z" fill={p.body} />
    </>
  );
}
